import { ReactNode } from 'react';
import * as S from './styles';

interface FieldProps {
	label: string;
	// Optional inline annotation next to the label (e.g. "(none)" for a
	// transparent color, or "(mixed)" for non-uniform padding).
	aside?: ReactNode;
	// Optional element placed on the right side of the header row (e.g. a
	// toggle button).
	accessory?: ReactNode;
	children: ReactNode;
}

const Field = ({ label, aside, accessory, children }: FieldProps) => {
	return (
		<S.Base>
			<S.Header>
				<S.Label>
					{label}
					{aside && <S.Aside>{aside}</S.Aside>}
				</S.Label>
				{accessory}
			</S.Header>
			{children}
		</S.Base>
	);
};

export default Field;
